import { useBreakpoints } from '@/composition/breakpoints'
import { ref } from '@/composition/vue/compositionApi'

export const useChatWidth = () => {
  const { isMobile } = useBreakpoints()
  const sidebarWidth = ref(isMobile.value ? 275 : 340)

  return { sidebarWidth }
}
